<template>
<div>
  <div class="card mgb-20px">
    <header class="header-card">
      <p>{{ $t('informationsGenerationCode.titleEmplacement') }}</p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-4">
          <b-field :label="$t('informationsGenerationCode.label.adresse')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{adresse}}
            </span>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('informationsGenerationCode.label.insee')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{element.adresseCadastrale.codeInsee}}
            </span>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    element: {
      type: Object,
      required: true,
    },
  },
  computed: {
    adresse() {
      const elementAdress = this.element.adresseCadastrale;
      let adresse = elementAdress.adresse1 || elementAdress.adresse2;
      if (elementAdress.codePostal) adresse += ' - ' + elementAdress.codePostal;
      if (elementAdress.ville) adresse += ' - ' + elementAdress.ville;
      return adresse;
    },
  },
};

</script>

<style>

</style>
